import AgedReceivablesCard from 'components/agedReceivables/AgedReceivablesCard';
import { useSelectedDataLevel } from 'waypoint-hooks';

export const AgedReceivablesSection = ({
    entityCode,
}: {
    entityCode: string;
}) => {
    const selectedDataLevel = useSelectedDataLevel();

    return (
        <div
            style={{ margin: '20px 0', padding: '0 24px' }}
            id="aged-receivables-section"
        >
            <div id="aged-receivables" style={{ marginTop: '20px' }}>
                <AgedReceivablesCard
                    selectedDataLevel={selectedDataLevel}
                    entityCodes={[entityCode]}
                    isPropertyProfilePage={true}
                />
            </div>
        </div>
    );
};
